/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalSchemeDto } from '../../models/medical-scheme-dto';

export interface MedicalSchemesElixirLiveGet$Params {
}

export function medicalSchemesElixirLiveGet(http: HttpClient, rootUrl: string, params?: MedicalSchemesElixirLiveGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<MedicalSchemeDto>>> {
  const rb = new RequestBuilder(rootUrl, medicalSchemesElixirLiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<Array<MedicalSchemeDto>>;
    })
  );
}

medicalSchemesElixirLiveGet.PATH = '/MedicalSchemes/ElixirLive';
